import detail from './detail'
import equip from './equip'
export default {
  detail,
  equip
}



// WEBPACK FOOTER //
// ./src/api/apis/integral/index.js